import { CloudText, Reveal, AltitudeMarker } from '@/components/CloudText';

export function AboutSection() {
  return (
    <section id="about" className="relative min-h-[90vh] px-6 sm:px-[8vw] py-[18vh] flex items-center" data-testid="about-section">
      <AltitudeMarker index="05" label="ABOUT" />
      <div className="relative w-full max-w-5xl mx-auto">
        <div className="absolute -inset-x-[15%] -inset-y-[20%] pointer-events-none" style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(255,255,255,0.28), rgba(255,255,255,0.08) 40%, rgba(255,255,255,0) 70%)', filter: 'blur(30px)' }} />
        <Reveal>
          <div className="glass-deep relative cloud-shape px-8 py-16 sm:px-20 sm:py-24" style={{ boxShadow: 'inset 0 0 80px 20px rgba(255,255,255,0.22), 0 40px 120px rgba(2,10,30,0.5)' }}>
            <p className="cloud-eyebrow mb-5">Altitude 05 — The studio</p>
            <CloudText lines={['WHY STORYSPARK?']} size="text-3xl sm:text-5xl lg:text-6xl" testId="about-title" />
            <div className="mt-10 space-y-6 text-base sm:text-lg text-white/85 leading-relaxed max-w-3xl" data-testid="about-text">
              <p>StorySpark Studios turns ideas into visual experiences.</p>
              <p>From logos and promotional graphics to websites and immersive digital experiences, we build visuals designed to make brands stand out.</p>
              <p>Whether you’re starting from scratch or leveling up an existing brand, bring us your idea and we’ll help turn it into something people remember.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
